import {addNamespace} from '#/notes/store/helpers'

export const actionTypes = {
  FETCH_AUTHORS: 'fetchAuthors'
}

export default addNamespace('notes/authors/', actionTypes)
